
import React from 'react';

const Arrow = () => {
    return (
        <div> 
            <svg className="svg-arrow" viewBox="0 0 32 64" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0V6.1539L25.849 31.9985L0 57.8461V64L32 31.9985L0 0Z"/>
            </svg>
        </div>
    )
}

export default Arrow;